import { h, } from '@stencil/core';
import { addDaysToDate, closestAcrossShadow, findLocale, formatDate, formatIsoDate, i18n, isAustrianHoliday, parseDate } from '../../utils';
import { dateFieldI18n } from './date-field-i18n';
export class DateField {
  constructor() {
    this.daysValid = true;
    this.previousBtnDisabled = false;
    this.nextBtnDisabled = false;
    this.fieldIsValid = undefined;
    this.fieldIsDirty = undefined;
    this.fieldIsEmpty = undefined;
    this.name = undefined;
    this.mode = undefined;
    this.htmlId = undefined;
    this.htmlIdPrefix = 'oebb-date-field-';
    this.label = i18n.get('date', 'Datum');
    this.screenReaderLabel = false;
    this.startDateValue = undefined;
    this.startDate = undefined;
    this.required = true;
    this.valid = false;
    this.errorMessageId = undefined;
    this.addDays = undefined;
    this.disabledBefore = undefined;
    this.disabledAfter = undefined;
    this.disableSaturdays = false;
    this.novalidate = false;
    this.disableSundays = false;
    this.disableWeekends = false;
    this.disableHolidays = false;
  }
  //@Event() datefieldActive: EventEmitter;
  formDataChangedHandler() {
    //	console.log('trigger formDataChanged');
    this.formDataChanged.emit({
      name: this.name,
      value: this.date,
      valid: this.fieldIsValid && (!this.required || !this.fieldIsEmpty),
    });
    if (this.date)
      this.setPreviousAndNextButtonState(this.date);
  }
  disabledBeforeChanged(disabledBefore) {
    if (this.mode === '2022') {
      this.calendarEl.disabledBefore = disabledBefore;
    }
  }
  disabledAfterChanged(disabledAfter) {
    if (this.mode === '2022') {
      this.calendarEl.disabledAfter = disabledAfter;
    }
  }
  disableSaturdaysChanged(newValue) {
    if (this.mode === '2022') {
      this.calendarEl.disableSaturdays = newValue;
    }
    if (newValue && this.date.getDay() == 6) {
      this.setNextActiveDate(1);
      this.dateChanged.emit(this.date);
      this.formDataChangedHandler();
    }
  }
  disableSundaysChanged(newValue) {
    if (this.mode === '2022') {
      this.calendarEl.disableSundays = newValue;
    }
    if (newValue && this.date.getDay() == 0) {
      this.setNextActiveDate(1);
    }
  }
  disableWeekendsChanged(newValue) {
    if (this.mode === '2022') {
      this.calendarEl.disableWeekends = newValue;
    }
    if (newValue && (this.date.getDay() == 6 || this.date.getDay() == 0)) {
      this.setNextActiveDate(1);
      this.dateChanged.emit(this.date);
      this.formDataChangedHandler();
    }
  }
  disableHolidaysChanged(newValue) {
    if (this.mode === '2022') {
      this.calendarEl.disableHolidays = newValue;
    }
    if (newValue && isAustrianHoliday(this.date)) {
      this.setNextActiveDate(1);
      this.dateChanged.emit(this.date);
      this.formDataChangedHandler();
    }
  }
  componentWillLoad() {
    this.lang = findLocale(this.el);
    this.htmlIdInternal = this.htmlId
      ? this.htmlId
      : this.htmlIdPrefix + Math.random().toString(36).substring(2, 6);
    this.hasLabelOutside = this.htmlId ? true : false;
    i18n.setLang(this.lang);
    i18n.add(dateFieldI18n);
    if (this.addDays && this.addDays > 0) {
      this.addDaysDate = new Date(Date.now() + 60000 * 60 * 24 * this.addDays);
      this.addDaysDate.setMinutes(0);
      this.addDaysDate.setHours(0);
      this.addDaysDate.setSeconds(0);
      this.addDaysDate.setMilliseconds(0);
    }
    if (this.startDateValue) {
      this.startDate = new Date(this.startDateValue);
    }
    if (this.startDate && isNaN(this.startDate.valueOf())) {
      this.startDate = null;
    }
    if (this.mode == '2021') {
      if (!this.startDate)
        this.startDate = new Date();
    }
    if (this.startDate) {
      this.date = this.startDate;
    }
    this.setPreviousAndNextButtonState(this.date);
    this.fieldIsValid = true;
    this.fieldIsEmpty = !this.date;
    const form = closestAcrossShadow(this.el, 'form');
    form === null || form === void 0 ? void 0 : form.addEventListener('formdata', e => {
      if (this.name && this.date && this.fieldIsValid) {
        return e.formData.append(this.name, formatIsoDate(this.date));
      }
    });
  }
  componentDidLoad() {
    this.dateFieldEl = this.el.shadowRoot.querySelector('.js-oebb-date-field');
    this.dateInput = this.el.shadowRoot.querySelector('input');
    if (this.mode === '2022') {
      this.calendarEl = document.createElement('oebbx-calendar');
      this.calendarEl.setAttribute('mode', this.mode);
      this.calendarEl.setAttribute('lang', this.lang);
      this.calendarEl.setAttribute('tabindex', '-1');
      this.calendarEl.setAttribute('aria-hidden', 'true');
      this.calendarEl.disabledBefore = this.disabledBefore;
      this.calendarEl.disabledAfter = this.disabledAfter;
      this.calendarEl.disableSaturdays = this.disableSaturdays;
      this.calendarEl.disableSundays = this.disableSundays;
      this.calendarEl.disableWeekends = this.disableWeekends;
      this.calendarEl.disableHolidays = this.disableHolidays;
      // noinspection JSIgnoredPromiseFromCall
      this.calendarEl.setDateInput(this.dateInput);
      // The @Listen annotation below won't work anymore since the calendar is somewhere else in the DOM
      this.calendarEl.addEventListener('dateChanged', (e) => this.dateChangedHandler(e));
      // Append at the end of the body
      document.body.append(this.calendarEl);
    }
    else {
      this.calendarEl = this.el.shadowRoot.querySelector('oebbx-calendar');
    }
    if (this.date) {
      this.dateInput.value = formatDate(this.date);
      this.calendarEl.setDate(this.date);
    }
  }
  componentWillUpdate() {
    if (this.required && this.fieldIsEmpty && this.startDate) {
      this.date = this.startDate;
      this.dateInput.value = formatDate(this.date);
      this.validate();
    }
  }
  disconnectedCallback() {
    var _a;
    if (this.mode === '2022') {
      (_a = this.calendarEl) === null || _a === void 0 ? void 0 : _a.remove();
    }
  }
  handleBodyClick(e) {
    if (!e.composedPath().includes(this.el)) {
      this.calendarEl.hide();
    }
  }
  handleFocusOut(event) {
    var _a;
    event.preventDefault();
    if (!((_a = this.calendarEl) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
      // The 2022 style calendar is located somewhere else in the DOM, we need to check if the focus moved there
      this.calendarEl.hide();
    }
  }
  datefieldActiveHandler(event) {
    event.stopPropagation();
    //console.log("datefieldActive", event)
    if (!event.composedPath().includes(this.el)) {
      this.calendarEl.hide();
    }
  }
  dateChangedHandler(event) {
    if (this.addDays) {
      let myDate = event.detail;
      if (myDate.getTime() >= this.addDaysDate.getTime()) {
        this.daysValid = true;
        this.date = myDate;
      }
      else {
        this.daysValid = false;
        event.stopPropagation();
      }
    }
    this.date = event.detail;
    this.calendarEl.setDate(this.date);
    this.validate();
    this.setPreviousAndNextButtonState(event.detail);
    this.formDataChangedHandler();
  }
  async setDate(date) {
    this.date = date;
    this.dateInput.value = formatDate(this.date);
    this.calendarEl.setDate(this.date);
    this.fieldIsDirty = true;
    this.validate();
    this.formDataChangedHandler();
  }
  async getDate() {
    return Promise.resolve(this.date);
  }
  async getValue() {
    return Promise.resolve(this.dateInput.value);
  }
  async setFocus() {
    this.el.shadowRoot.querySelector('input').focus();
  }
  async onFieldInput() {
    this.date = parseDate(this.dateInput.value);
  }
  onFieldKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
        this.calendarEl.focusCalendar();
        e.preventDefault();
        break;
      case 'Escape':
        this.calendarEl.hide();
        break;
    }
  }
  onFieldFocus(e) {
    e.stopPropagation();
    this.dateFieldEl.classList.add('focus');
    if (this.mode == '2021' || this.mode === '2022') {
      this.datefieldActive.emit(this.name);
      this.calendarEl.show();
    }
  }
  onFieldBlur() {
    this.dateFieldEl.classList.remove('focus');
  }
  onFieldChange() {
    this.date = parseDate(this.dateInput.value);
    if (this.date && this.date.toString() !== 'Invalid Date') {
      this.dateInput.value = formatDate(this.date);
      this.fieldIsDirty = true;
      this.validate();
      if (this.fieldIsValid) {
        if (this.disabledBefore &&
          this.date.setHours(0, 0, 0, 0) <
            this.disabledBefore.setHours(0, 0, 0, 0))
          this.setNextActiveDate(1);
        if (this.disabledAfter &&
          this.date.setHours(0, 0, 0, 0) >
            this.disabledAfter.setHours(0, 0, 0, 0))
          this.setNextActiveDate(-1);
        if (this.disableSaturdays && this.date.getDay() == 6)
          this.setNextActiveDate(1);
        if (this.disableSundays && this.date.getDay() == 0)
          this.setNextActiveDate(1);
        if (this.disableWeekends &&
          (this.date.getDay() == 6 || this.date.getDay() == 0))
          this.setNextActiveDate(1);
        if (this.disableHolidays && isAustrianHoliday(this.date))
          this.setNextActiveDate(1);
        this.dateChanged.emit(this.date);
      }
      else if (this.novalidate) {
        this.dateChanged.emit(this.date);
      }
      this.formDataChangedHandler();
    }
    else {
      this.fieldIsDirty = true;
      this.validate();
      this.formDataChangedHandler();
    }
  }
  onPreviousBtnClick(e) {
    e.stopPropagation(); // Stop bubbling to not trigger document click event which removes 'is-tabbing' class
    if (!this.date)
      this.date = new Date();
    this.setNextActiveDate(-1);
    this.dateInput.value = '';
    setTimeout(() => {
      this.dateInput.value = formatDate(this.date);
    }, 10); // Timeout for screen reader to read whole date
    this.dateChanged.emit(this.date);
  }
  onNextBtnClick(e) {
    e.stopPropagation(); // Stop bubbling to not trigger document click event which removes 'is-tabbing' class
    if (!this.date)
      this.date = new Date();
    this.setNextActiveDate(1);
    this.dateInput.value = '';
    setTimeout(() => {
      this.dateInput.value = formatDate(this.date);
    }, 10); // Timeout for screen reader to read whole date
    this.dateChanged.emit(this.date);
    this.formDataChangedHandler();
  }
  onPreviousBtnKeyDown(e) {
    if (e.shiftKey && e.keyCode === 9) {
      this.firstElementLostFocusBackwards.emit();
    }
  }
  onCalendarBtnClick(e) {
    e.stopPropagation();
    this.datefieldActive.emit(this.name);
    this.calendarEl.toggle();
    //this.datefieldActive.emit(this.name)
  }
  setNextActiveDate(days) {
    const step = Math.sign(days);
    days = Math.abs(days);
    while (days > 0) {
      this.date = addDaysToDate(step, this.date);
      if (this.disableWeekends && this.date.getDay() == 6)
        continue;
      if (this.disableWeekends && this.date.getDay() == 0)
        continue;
      if (this.disableSundays && this.date.getDay() == 0)
        continue;
      if (this.disableSaturdays && this.date.getDay() == 6)
        continue;
      if (this.disableHolidays && isAustrianHoliday(this.date))
        continue;
      days--;
    }
  }
  setPreviousAndNextButtonState(date) {
    if (this.disabledBefore &&
      date.setHours(0, 0, 0, 0) ==
        this.disabledBefore.setHours(0, 0, 0, 0)) {
      this.previousBtnDisabled = true;
    }
    else {
      this.previousBtnDisabled = false;
    }
    if (this.disabledAfter &&
      date.setHours(0, 0, 0, 0) == this.disabledAfter.setHours(0, 0, 0, 0)) {
      this.nextBtnDisabled = true;
    }
    else {
      this.nextBtnDisabled = false;
    }
  }
  /** Gibt den Validierungsstatus als Boolean zurück. */
  async isValid() {
    if (!this.fieldIsDirty) {
      await this.validate();
      this.fieldIsDirty = true;
    }
    return Promise.resolve(this.fieldIsValid && (!this.required || !this.fieldIsEmpty));
  }
  validate() {
    if (!this.date && this.dateInput.value.length > 0) {
      this.fieldIsValid = false;
      this.fieldIsEmpty = false;
    }
    else if (!this.date) {
      this.fieldIsValid = true;
      this.fieldIsEmpty = true;
    }
    else if (!this.date || this.date.toString() == 'Invalid Date') {
      this.fieldIsValid = false;
      this.fieldIsEmpty = false;
    }
    else {
      let validationStatus = true;
      if (validationStatus && this.disabledAfter) {
        if (this.disabledAfter.setHours(0, 0, 0, 0) < this.date.setHours(0, 0, 0, 0)) {
          //console.log("disabledAfter: " + this.disabledAfter)
          //	console.log("date: " + this.date)
          validationStatus = false;
        }
      }
      if (validationStatus && this.disabledBefore) {
        if (this.disabledBefore.setHours(0, 0, 0, 0) > this.date.setHours(0, 0, 0, 0)) {
          //	console.log("disabledBefore: " + this.disabledAfter)
          //		console.log("date: " + this.date)
          validationStatus = false;
        }
      }
      this.fieldIsValid = validationStatus;
      this.fieldIsEmpty = false;
    }
  }
  renderValidationMessages() {
    if (this.novalidate)
      return;
    if (!this.fieldIsDirty) {
      return null;
    }
    if (this.required && this.fieldIsEmpty) {
      return (h("div", { id: this.errorMessageId, class: "oebb-date-field--invalid-message" }, i18n.get('date-missing', 'Wählen Sie bitte ein Datum aus.')));
    }
    if (!this.fieldIsValid) {
      return (h("div", { id: this.errorMessageId, class: "oebb-date-field--invalid-message" }, i18n.get('date-invalid', 'Das Datum ist ungültig.')));
    }
    return null;
  }
  onMouseLeave(e) {
    e.stopPropagation();
    //this.calendarEl.hide();
  }
  render() {
    if (this.mode && (this.mode == '2021' || this.mode === '2022')) {
      return [
        h("div", { onMouseLeave: (e) => this.onMouseLeave(e), class: {
            'oebb-date-field': true,
            'js-oebb-date-field': true,
            error: !this.daysValid,
            'oebb-date-field--invalid': (!this.fieldIsValid || (this.required && this.fieldIsEmpty)) && this.fieldIsDirty,
          } }, !this.hasLabelOutside && this.mode === '2021' ? (h("label", { htmlFor: this.htmlIdInternal, id: this.htmlIdInternal + '-label', class: {
            'screen-reader-text': this.screenReaderLabel,
          } }, this.label)) : (''), h("input", { type: "text", id: this.htmlIdInternal, name: "oebb-date-field-input", autocomplete: "off", class: {
            'oebb-date-field-input': true,
          }, onKeyDown: (e) => this.onFieldKeyDown(e), onInput: () => this.onFieldInput(), onChange: () => this.onFieldChange(), onFocus: (e) => this.onFieldFocus(e), onBlur: () => this.onFieldBlur(), placeholder: this.mode === '2022' ? this.label : '', "aria-label": `${this.label} ${i18n.get('date-format', 'Format TT.MM.JJJJ')}`, "aria-live": "polite", "aria-required": this.required + '' }), this.mode === '2022' ? (h("label", { htmlFor: this.htmlIdInternal, id: this.htmlIdInternal + '-label', class: "form-label-text" }, this.label)) : null, h("button", { tabindex: "-1", "aria-hidden": "true", onClick: (e) => this.onCalendarBtnClick(e) }, h("slot", { name: "icon" }, h("oebbx-icon", { name: "calendar" })), h("span", { class: "screen-reader-text" }, i18n.get('open-calendar', 'Kalender öffnen'))), this.mode === '2021' ? h("oebbx-calendar", { mode: this.mode, lang: this.lang, "input-selector": '#' + this.htmlIdInternal, tabindex: "-1", "aria-hidden": "true", disabledBefore: this.disabledBefore, disabledAfter: this.disabledAfter, disableSaturdays: this.disableSaturdays, disableSundays: this.disableSundays, disableWeekends: this.disableWeekends, disableHolidays: this.disableHolidays }) : null),
        this.renderValidationMessages()
      ];
    }
    return [
      h("div", { class: {
          'date-field': true,
          'js-oebb-date-field': true,
          error: !this.daysValid,
          'oebb-date-field--invalid': (!this.fieldIsValid || (this.required && this.fieldIsEmpty)) && this.fieldIsDirty,
        } }, h("button", { type: "button", onClick: (e) => this.onPreviousBtnClick(e), onKeyDown: (e) => this.onPreviousBtnKeyDown(e), disabled: this.previousBtnDisabled }, h("span", { class: "screen-reader-text" }, i18n.get('date-previous', 'Vorheriger Tag')), h("oebbx-icon", { name: "triangle", svgStyle: { transform: 'rotate(180deg)' }, "aria-hidden": "true" })), !this.hasLabelOutside ? (h("label", { htmlFor: this.htmlIdInternal, class: { 'screen-reader-text': this.screenReaderLabel } }, i18n.get('date', 'Datum'), ":")) : (''), h("input", { type: "text", name: "date", id: this.htmlIdInternal, value: "", onInput: () => this.onFieldInput(), onChange: () => this.onFieldChange(), onFocus: (e) => this.onFieldFocus(e), onBlur: () => this.onFieldBlur(), "aria-label": i18n.get('date-format', 'Datum Format TT.MM.JJJJ'), "aria-live": "polite", "aria-required": this.required + '', "aria-invalid": this.novalidate ? false : !this.valid + '', "aria-describedby": this.errorMessageId, class: { 'label-outside': this.hasLabelOutside } }), h("button", { type: "button", onClick: (e) => this.onNextBtnClick(e), disabled: this.nextBtnDisabled }, h("span", { class: "screen-reader-text" }, i18n.get('date-next', 'Nächster Tag')), h("oebbx-icon", { name: "triangle", width: "16", height: "16", "aria-hidden": "true" }))),
      h("button", { type: "button", class: "calendar-btn", onClick: (e) => this.onCalendarBtnClick(e), tabindex: "-1", "aria-hidden": "true" }, h("span", { class: "screen-reader-text" }, i18n.get('open-calendar', 'Kalender öffnen')), h("oebbx-icon", { name: "calendar", width: "24", height: "24", "aria-hidden": "true" })),
      h("oebbx-calendar", { lang: this.lang, "input-selector": '#' + this.htmlIdInternal, "aria-hidden": "true", disabledBefore: this.disabledBefore, disabledAfter: this.disabledAfter, disableSaturdays: this.disableSaturdays, disableSundays: this.disableSundays, disableWeekends: this.disableWeekends, disableHolidays: this.disableHolidays }),
      !this.daysValid && this.addDaysDate ? (h("div", null, h("span", { class: "fm-label-danger" }, [
        i18n.get('date-valid-from-1', 'Das Datum ist erst ab ') +
          formatDate(this.addDaysDate) +
          i18n.get('date-valid-from-2', 'gültig.'),
      ]))) : (''),
    ];
  }
  static get is() { return "oebbx-date-field"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "2021": ["date-field-2021.scss"],
      "2022": ["date-field-2022.scss"],
      "default": ["date-field.css"]
    };
  }
  static get styleUrls() {
    return {
      "2021": ["date-field-2021.css"],
      "2022": ["date-field-2022.css"],
      "default": ["date-field.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "mode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "mode",
        "reflect": false
      },
      "htmlId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "html-id",
        "reflect": false
      },
      "htmlIdPrefix": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "html-id-prefix",
        "reflect": false,
        "defaultValue": "'oebb-date-field-'"
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false,
        "defaultValue": "i18n.get('date', 'Datum')"
      },
      "screenReaderLabel": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "screen-reader-label",
        "reflect": false,
        "defaultValue": "false"
      },
      "startDateValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "start-date-value",
        "reflect": false
      },
      "startDate": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "Date",
          "resolved": "Date",
          "references": {
            "Date": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "required": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "required",
        "reflect": false,
        "defaultValue": "true"
      },
      "valid": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "valid",
        "reflect": false,
        "defaultValue": "false"
      },
      "errorMessageId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error-message-id",
        "reflect": false
      },
      "addDays": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-days",
        "reflect": false
      },
      "disabledBefore": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Date",
          "resolved": "Date",
          "references": {
            "Date": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "disabledAfter": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Date",
          "resolved": "Date",
          "references": {
            "Date": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "disableSaturdays": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-saturdays",
        "reflect": false,
        "defaultValue": "false"
      },
      "novalidate": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "novalidate",
        "reflect": false,
        "defaultValue": "false"
      },
      "disableSundays": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-sundays",
        "reflect": false,
        "defaultValue": "false"
      },
      "disableWeekends": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-weekends",
        "reflect": false,
        "defaultValue": "false"
      },
      "disableHolidays": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disable-holidays",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "daysValid": {},
      "previousBtnDisabled": {},
      "nextBtnDisabled": {},
      "fieldIsValid": {},
      "fieldIsDirty": {},
      "fieldIsEmpty": {}
    };
  }
  static get events() {
    return [{
        "method": "datefieldActive",
        "name": "datefieldActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "formDataChanged",
        "name": "formDataChanged",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "firstElementLostFocusBackwards",
        "name": "firstElementLostFocusBackwards",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "dateChanged",
        "name": "dateChanged",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get methods() {
    return {
      "setDate": {
        "complexType": {
          "signature": "(date: Date) => Promise<void>",
          "parameters": [{
              "tags": [],
              "text": ""
            }],
          "references": {
            "Promise": {
              "location": "global"
            },
            "Date": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "getDate": {
        "complexType": {
          "signature": "() => Promise<Date>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            },
            "Date": {
              "location": "global"
            }
          },
          "return": "Promise<Date>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "getValue": {
        "complexType": {
          "signature": "() => Promise<string>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<string>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "setFocus": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "onFieldInput": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      },
      "isValid": {
        "complexType": {
          "signature": "() => Promise<boolean>",
          "parameters": [],
          "references": {
            "Promise": {
              "location": "global"
            }
          },
          "return": "Promise<boolean>"
        },
        "docs": {
          "text": "Gibt den Validierungsstatus als Boolean zur\u00FCck.",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "disabledBefore",
        "methodName": "disabledBeforeChanged"
      }, {
        "propName": "disabledAfter",
        "methodName": "disabledAfterChanged"
      }, {
        "propName": "disableSaturdays",
        "methodName": "disableSaturdaysChanged"
      }, {
        "propName": "disableSundays",
        "methodName": "disableSundaysChanged"
      }, {
        "propName": "disableWeekends",
        "methodName": "disableWeekendsChanged"
      }, {
        "propName": "disableHolidays",
        "methodName": "disableHolidaysChanged"
      }];
  }
  static get listeners() {
    return [{
        "name": "click",
        "method": "handleBodyClick",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "focusout",
        "method": "handleFocusOut",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "datefieldActive",
        "method": "datefieldActiveHandler",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "dateChanged",
        "method": "dateChangedHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=date-field.js.map
